import LocalizedStrings from 'localized-strings';

import { PaymentCardStatus } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    advantages: {
      pay: 'Pay with your smartphone, via Apple Pay et Google Pay',
      secure: 'Ideal for secure online purchases',
      swift: 'Deactivate with a single click for extra security',
    },
    basicPlan: {
      buttonText: 'Activate a virtual card',
      creationSuccessMessage: 'Your card has been ordered.',
      description:
        'While waiting for your physical card to be delivered, a virtual card can be activated for immediate use.',
      price: 'Price',
      pricePerMonth: '**€{0}**/month',
      skip: 'Skip',
      warning:
        'You have insufficient funds for this order, please ensure your balance is sufficient to order your card.',
    },
    buttonText: 'See my cards',
    cardName: 'Virtual Card',
    cvv: 'CVV: ',
    cvvMasked: '•••',
    description:
      'While waiting for your physical card to be delivered, the virtual card included in your offer has been activated. This card can be used immediately.',
    descriptionWithDelay:
      'While waiting for your physical card to be delivered, the virtual card included in your offer is being created. It will be active within 48 hours and will allow you to use your account.',
    detailsTitle: 'Details of your virtual card:',
    expirationDate: 'EXP: ',
    expirationDateMasked: '••/••',
    learnMore: 'Learn more about virtual cards',
    maskedPan: '{panStart} •••• •••• {panEnd}',
    orderErrorMessage: 'Your card could not be ordered, please try again',
    status: {
      [PaymentCardStatus.Active]: 'Active',
    },
    statusWithDelay: 'Available within 48 hours',
    title: 'Your card has been ordered. Don’t wait for it to start!',
  },
  fr: {
    advantages: {
      pay: 'Payez avec votre smartphone, via Apple Pay et Google Pay',
      secure: 'Idéale pour vos achats en ligne en toute sécurité',
      swift: 'Désactivable en un clic pour plus de sécurité',
    },
    basicPlan: {
      buttonText: 'Activer une carte virtuelle',
      creationSuccessMessage: 'Votre carte a été commandée.',
      description:
        'En attendant la livraison de votre carte physique, une carte virtuelle peut être activée pour une utilisation immédiate.',
      price: 'Prix',
      pricePerMonth: '**{0}\xA0€**/mois',
      skip: 'Ignorer',
      warning:
        'Les fonds sont insuffisants pour cette commande, veuillez vous assurer que votre solde est suffisant pour commander votre carte.',
    },
    buttonText: 'Voir mes cartes',
    cardName: 'Carte virtuelle',
    cvv: 'CVV\xa0: ',
    cvvMasked: '•••',
    description:
      'En attendant la livraison de votre carte physique, une carte virtuelle incluse dans votre offre a été activée. Cette carte est immédiatement utilisable.',
    descriptionWithDelay: `En attendant la livraison de votre carte physique, une carte virtuelle incluse dans votre offre est en cours de création. Elle sera active d'ici 48h et vous permettra de commencer à utiliser votre compte.`,
    detailsTitle: 'Votre carte virtuelle en détail\xa0:',
    expirationDate: 'EXP\xa0:',
    expirationDateMasked: '••/••',
    learnMore: 'En savoir plus sur les cartes virtuelles',
    maskedPan: '{panStart} •••• •••• {panEnd}',
    orderErrorMessage: `Votre carte n'a pas pu être commandée, veuillez réessayer`,
    status: {
      [PaymentCardStatus.Active]: 'Activée',
    },
    statusWithDelay: 'Dispo sous 48h',
    title:
      'Votre carte a bien été commandée. Ne l’attendez pas pour démarrer\xa0!',
  },
} as const);

export default locales;
